import { render, staticRenderFns } from "./advertisementEdit.vue?vue&type=template&id=11965767&scoped=true&"
import script from "./advertisementEdit.vue?vue&type=script&lang=js&"
export * from "./advertisementEdit.vue?vue&type=script&lang=js&"
import style0 from "./advertisementEdit.vue?vue&type=style&index=0&id=11965767&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11965767",
  null
  
)

export default component.exports